import { CheckCircle2, Lock } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { ProfileModel } from '@/types'

interface ProfileSecurityProps {
    profile: ProfileModel.Profile
    onChangePassword: () => void
    onLogout: () => void
}

export const ProfileSecurity = ({ profile, onChangePassword, onLogout }: ProfileSecurityProps) => {
    const SecurityItem = ({ label, isVerified, onVerify, description }: any) => (
        <div className="flex flex-col justify-between gap-2 py-3 sm:flex-row sm:items-center">
            <div className="min-w-0 space-y-1">
                <div className="flex items-center gap-2">
                    <p className="text-sm font-medium text-ink">{label}</p>
                    {isVerified ? (
                        <Badge tone="success">Verified</Badge>
                    ) : (
                        <Badge tone="warning">Pending</Badge>
                    )}
                </div>
                <p className="break-all text-sm text-text-2 sm:break-normal">{description}</p>
            </div>
            <div className="flex sm:block">
                {isVerified ? (
                    <CheckCircle2 className="size-5 text-success" />
                ) : (
                    <Button size="sm" variant="outline" className="w-full sm:w-auto" onClick={onVerify}>
                        Verify
                    </Button>
                )}
            </div>
        </div>
    )

    return (
        <Card>
            <CardHeader>
                <CardTitle>Security</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
                <div className="divide-y divide-border-subtle">
                    <SecurityItem
                        label="Email"
                        description={`Your email address is ${profile.email}`}
                        isVerified={profile.is_email_verified}
                    />
                    <SecurityItem
                        label="Phone"
                        description={profile.phone ? `Registered: ${profile.phone}` : 'No phone number registered'}
                        isVerified={profile.is_phone_verified}
                    />
                </div>

                <div className="space-y-2 border-t border-border-subtle pt-4">
                    <Button
                        variant="secondary"
                        className="w-full"
                        onClick={onChangePassword}>
                        <Lock /> Change password
                    </Button>
                    <Button
                        variant="outline"
                        className="w-full"
                        onClick={onLogout}>
                        Log out
                    </Button>
                </div>
            </CardContent>
        </Card>
    )
}
